import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare var $: any;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


$(document).on('click', '#togglebutton', function () {
  if ($(window).width() > 500) { 
    $('.sidenav__item--text').toggle();
    $('.sidenav__logo').toggle();
    $('.sidenav__logo--udn').toggle();
  } else {
    $('.sidenav').animate({
      width: 'toggle'
    }, 350);
  }
});

$(document).on('click', '#btn-dropdown', function (event) {
  $('#notificaciones').hide();
  event.preventDefault();
  $('#dropdown-menu').toggle();
})

$(document).on("contextmenu",function(e){
  return false;
});
// $(document).bind("contextmenu",function(e){
//   return false;
// });

